<template>
  <section>

    <container v-if="$store.state.isNewSinglefamilyProperty">

      <p class="title is-bold">
        <i
          class="fas fa-home fa-1x"
          style="margin-right: .3em"
        ></i>
        New single-family property
      </p>

      <div class="columns">

        <div class="column">
          <div>Address search</div>

          <div class="field">
            <div class="control">
              <vue-google-autocomplete
                class="input"
                id="map"
                :country="['us']"
                classname="form-control"
                placeholder="Property address..."
                v-on:placechanged="getAddressData"
              >
              </vue-google-autocomplete>
            </div>
            <!-- {{ this.autocompleteAddress }} -->
          </div>

          <div>New Property (by address)</div>
          <div class="field">
            <div class="control">
              <input
                @focus="$event.target.select()"
                class="input"
                v-model="newPropertyByAddress.address"
                type="text"
                placeholder="Address..."
              >
            </div>
          </div>

          <div class="columns">

            <div class="column is-4">
              <div class="field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-model="newPropertyByAddress.city"
                    type="text"
                    placeholder="City..."
                  >
                </div>
              </div>
            </div>

            <div class="column is-4">
              <div class="field">
                <div class="control">
                  <b-select
                    expanded
                    v-model="newPropertyByAddress.state"
                  >
                    <option value="">Select state</option>
                    <option
                      v-for="(state, key) in $store.state.states"
                      :key="key"
                      :value="state"
                    >{{ state }}</option>
                  </b-select>
                </div>
              </div>
            </div>

            <div class="column is-4">
              <div class="field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-model="newPropertyByAddress.zip"
                    type="text"
                    placeholder="Zip..."
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="control">
            <button
              v-on:click="createPropertyByAddress()"
              class="button is-primary"
            >Create Property by Address</button>
          </div>

        </div>

        <div
          class="is-divider-vertical"
          data-content="OR"
        ></div>

        <div class="column">
          <div>New Property (by MLS #)</div>
          <div class="field">
            <div class="control">
              <b-select
                placeholder="Select a market"
                v-model="newPropertyByMlsNumber.market"
                expanded
              >
                <option
                  v-for="(mlsMarket, key) in $store.state.mlsMarkets"
                  :key="key"
                  v-bind:value="mlsMarket.acronym"
                >
                  {{ mlsMarket.acronym }} - {{ mlsMarket.description }}
                </option>
              </b-select>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input
                @keydown="$log"
                @focus="$event.target.select()"
                class="input"
                v-model="newPropertyByMlsNumber.mlsNumber"
                type="text"
                placeholder="Mls Number..."
              >
            </div>
          </div>
          <div class="control">
            <button
              v-on:click="createPropertyByMlsNumber()"
              class="button is-primary"
            >Create Property by MLS #</button>
          </div>
        </div>

      </div>

    </container>

    <container v-if="$store.state.isNewMultifamilyProperty">

      <p class="title is-bold">
        <i
          class="fas fa-building fa-1x"
          style="margin-right: .3em"
        ></i>
        New multifamily property
      </p>

      <div class="columns">

        <div class="column">
          <div>Address search</div>

          <div class="field">
            <div class="control">
              <vue-google-autocomplete
                class="input"
                id="map"
                :country="['us']"
                placeholder="Property address..."
                v-on:placechanged="getAddressData"
              >
              </vue-google-autocomplete>
            </div>
            <!-- {{ this.autocompleteAddress }} -->
          </div>

          <div>New Multifamily Property</div>
          <div class="field">
            <div class="control">
              <input
                @focus="$event.target.select()"
                class="input"
                v-model="newPropertyByAddress.address"
                type="text"
                placeholder="Address..."
              >
            </div>
          </div>

          <div class="columns">

            <div class="column is-4">
              <div class="field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-model="newPropertyByAddress.city"
                    type="text"
                    placeholder="City..."
                  >
                </div>
              </div>
            </div>

            <div class="column is-4">
              <div class="field">
                <div class="control">
                  <b-select
                    expanded
                    v-model="newPropertyByAddress.state"
                  >
                    <option value="">Select state</option>
                    <option
                      v-for="(state, key) in $store.state.states"
                      :key="key"
                      :value="state"
                    >{{ state }}</option>
                  </b-select>
                </div>
              </div>
            </div>

            <div class="column is-4">
              <div class="field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-model="newPropertyByAddress.zip"
                    type="text"
                    placeholder="Zip..."
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="control">
            <button
              v-on:click="createMultifamily()"
              class="button is-primary"
            >Create Now</button>
          </div>

        </div>

        <div class="column">

          <div>Property Name</div>
          <div class="field">
            <div class="control">
              <input
                @focus="$event.target.select()"
                class="input"
                v-model="newPropertyByAddress.multifamilyAttributes.propertyName"
                type="text"
                placeholder="Property name..."
              >
            </div>
          </div>

          <div class="columns">

            <div class="column is-4">
              <div>Units</div>
              <div class="field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-model="newPropertyByAddress.multifamilyAttributes.units"
                    type="number"
                    placeholder="Units..."
                  >
                </div>
              </div>
            </div>

            <div class="column is-4">
              <div>Year Built</div>
              <div class="field">
                <div class="control">
                  <input
                    @focus="$event.target.select()"
                    class="input"
                    v-model="newPropertyByAddress.multifamilyAttributes.yearBuilt"
                    type="number"
                    placeholder="Year built..."
                  >
                </div>
              </div>
            </div>

            <div class="column is-4">
              <div>Class</div>
              <div class="field">
                <div class="control">
                  <b-select
                    expanded
                    v-model="newPropertyByAddress.multifamilyAttributes.propertyClass"
                  >
                    <option value="">Select class</option>
                    <option value="Class A">Class A</option>
                    <option value="Class B">Class B</option>
                    <option value="Class C">Class C</option>
                    <option value="Class D">Class D</option>
                  </b-select>
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>

    </container>

  </section>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import Divider from "bulma-divider/dist/css/bulma-divider.min.css";
import axios from "axios";

export default {
  components: {
    VueGoogleAutocomplete,
    Divider,
    axios
  },

  watch: {
    selected() {
      this.newPropertyByAddress.address = this.selected.line;
      this.newPropertyByAddress.city = this.selected.city;
      this.newPropertyByAddress.state = this.selected.state_code;
      this.newPropertyByAddress.zip = this.selected.postal_code;
      this.newPropertyByAddress.latitude = this.selected.latitude;
      this.newPropertyByAddress.longitude = this.selected.longitude;
    }
  },

  data() {
    return {
      data: [],
      addressLookup: "",
      selected: null,

      autocompleteAddress: "",
      newPropertyByAddress: {
        address: "",
        city: "",
        state: "",
        zip: "",
        latitude: 0,
        longitude: 0,
        multifamilyAttributes: {
          propertyName: "",
          units: 0,
          yearBuilt: 0,
          propertyClass: ""
        }
      },
      newPropertyByMlsNumber: {
        market: "",
        mlsNumber: ""
      }
    };
  },

  async mounted() {
    await this.$store.dispatch("getMlsMarkets");
    await this.$store.dispatch("getStates");
    if (this.$store.getters.session)
      this.newPropertyByMlsNumber.market = this.$store.getters.session.user.preferences.mlsMarket;
  },

  methods: {
    getAddressData: function(addressData, placeResultData, id) {
      console.log("getAddressData()");
      this.address = id;
      this.autocompleteAddress = addressData;
      this.newPropertyByAddress.address =
        addressData.street_number + " " + addressData.route;
      this.newPropertyByAddress.city = addressData.locality;
      this.newPropertyByAddress.state = addressData.administrative_area_level_1;
      this.newPropertyByAddress.zip = addressData.postal_code;
      this.newPropertyByAddress.latitude = addressData.latitude;
      this.newPropertyByAddress.longitude = addressData.longitude;
    },

    async createMultifamily() {
      console.log("createMultifamily()");

      await this.$store
        .dispatch("newMultifamilyProperty", this.newPropertyByAddress)
        .then(async response => {
          console.log(response);
          console.log("Switching to property details page");
          await this.$router.push({
            name: "PropertyDetails",
            params: {
              property_id: this.$store.state.property.id
            }
          });
        });
    },

    async createPropertyByAddress() {
      console.log("createPropertyByAddress()");

      if (!this.$store.getters.session) return;

      var address = this.newPropertyByAddress.address;
      var city = this.newPropertyByAddress.city;
      var state = this.newPropertyByAddress.state;
      var zip = this.newPropertyByAddress.zip;
      var latitude = this.newPropertyByAddress.latitude;
      var longitude = this.newPropertyByAddress.longitude;
      await this.$store
        .dispatch("newPropertyByAddress", {
          address,
          city,
          state,
          zip,
          latitude,
          longitude
        })
        .then(async response => {
          console.log(response);
          console.log("Switching to property details page");
          await this.$router.push({
            name: "PropertyDetails",
            params: {
              property_id: this.$store.state.property.id
            }
          });
        });
    },

    async createPropertyByMlsNumber() {
      console.log("createPropertyByMlsNumber()");

      if (!this.$store.getters.session) return;
      if (
        this.newPropertyByMlsNumber.mlsNumber == undefined ||
        this.newPropertyByMlsNumber.mlsNumber == ""
      )
        return;

      var mlsMarket = this.newPropertyByMlsNumber.market;
      var mlsNumber = this.newPropertyByMlsNumber.mlsNumber;
      await this.$store
        .dispatch("newPropertyByMlsNumber", {
          mlsMarket,
          mlsNumber
        })
        .then(async response => {
          console.log(response);
          console.log("Switching to property details page");
          await this.$router.push({
            name: "PropertyDetails",
            params: {
              property_id: this.$store.state.property.id
            }
          });
        });
    }
  }
};
</script>

<style>
@import "/bulma-divider/dist/css/bulma-divider.min.css";
</style>
